import React, { useEffect } from "react";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import { useFormik } from "formik";
import { useToast } from "../../../../Components/Others/ToastServices";
import { TextMediumBase, TextMediumSM } from "../../../../Components/Text/MediumText";
import {
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import axiosInstance from "../../../../Services/axiosCommon";
import { useState } from "react";
import * as yup from "yup";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import EditIcon from "../../../../Components/Icons/Edit";
import { NuInput } from "../../../../Components/Utils/Input";
import NuAmount from "../../../../Components/Utils/NuAmount";
import DeleteIcon from "../../../../Components/Icons/Delete";
import { GetAccess } from "../../../../Components/Utils/roles";

function RefillingPremission() {
    const toast = useToast();
    const { value: PurchaseRequestApprovalStatus } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "approvalStatus_po"
    );
    const { data: user } = UseDropDown("/user/drop-down");
    const [data, setData] = useState([]);
    const [showFilterDialog, setShowFilterDialog] = useState(false);
    const[showAmount,setShowAmount] = useState(false);
    const [editAmount,setEditAmount] = useState(false);
    const getData = () => {
      axiosInstance
        .get("/status-permission/by-module/refilling")
        .then((res) => {
          console.log("ss", res);
          setData(res?.data?.data || []);
        })
        .catch(() => {
          toast.open({
            type: "error",
            message: "Error",
            description: "Failed to fetch data.",
          });
        });
    };
  
    useEffect(() => {
      getData();
    }, []);
    const [createNew, setCreateNew] = useState({
      module: "refilling",
      status: "",
      users: [],
      approvalType: "",
      minAmount: "",
      maxAmount: ""
    });
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema: yup.object({
        status: yup.string().required("Status is requred!"),
        approvalType: yup.string().required("Approval Type is requred!"),

        users: yup.array().of(yup.string()).min(1, "At least one user is required!"),
      //   minAmount: yup
      //   .number()
      //   .typeError("Min Amount must be a number")
      //   .min(0, "Min Amount must be greater than or equal to 0")
      //   .required("Min Amount is required"),
      // maxAmount: yup
      //   .number()
      //   .typeError("Max Amount must be a number")
      //   .min(yup.ref("minAmount"), "Max Amount must be greater than or equal to Min Amount")
      //   .required("Max Amount is required"),
      }),
      onSubmit: async (value, { resetForm }) => {
        axiosInstance.post("/status-permission/multi-add", value).then((res) => {
          if (res.data?.status === true) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Created Successfully.",
            });
            resetForm();
            getData();
          } else if (res.data?.status === false && res.data?.error) {
            toast.open({
              type: "error",
              message: "Error",
              description: res.data.error || "Network error.",
            });
          } else {
            toast.open({
              type: "warning",
              message: "Warning",
              description: res.data?.msg || "Warning.",
            });
          }
        });
      },
    });
    const [editDataStatus,setEditDataStatus] = useState("");
    const [editApprovalType, setEditApprovalType] = useState("");
    const[amount,setAmount] = useState({
      minAmount:"",
      maxAmount:"",
      id:""
    });
    const[userId,setUserId] = useState("")
    const test = ()=>{
      let temp = []
      Object.keys(data).map((key) => {
        if (key === editDataStatus) {
        
          data[editDataStatus].map((item) => {
            console.log("value",item?.userId)
            temp.push(item?.userId)
          });
          // return temp;
        }
        // return null;
      })
      return temp
    }
    
    const [createNewEdit, setCreateNewEdit] = useState({
      module: "refilling",
      status:"",
      users: [],
      approvalType: ""
    });
  
    useEffect(()=>{
      setCreateNewEdit({
        module: "refilling",
        status: editDataStatus,
        users: test()||[],
        approvalType: editApprovalType || "",
      })
    },[editDataStatus])
  
      const formikEdit = useFormik({
        enableReinitialize: true,
        initialValues: createNewEdit,
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema: yup.object({
          // email: yup.string().required('Email is required!'),
        }),
        onSubmit: async (value, { resetForm }) => {
          const valueData = {
            ...value,
            module: "refilling",
            status: editDataStatus,
          }
          axiosInstance.post("/status-permission/multi-add", valueData).then((res) => {
            if (res.data?.status === true) {
              toast.open({
                type: "success",
                message: "Success",
                description: res.data?.msg || "Created Successfully.",
              });
              resetForm();
              getData();
              closeFilterDialog();
            } else if (res.data?.status === false && res.data?.error) {
              toast.open({
                type: "error",
                message: "Error",
                description: res.data.error || "Network error.",
              });
            } else {
              toast.open({
                type: "warning",
                message: "Warning",
                description: res.data?.msg || "Warning.",
              });
            }
          });
        },
      });

    const [amountEdit,setAmountEdit] = useState({
      module: "refilling",
      status:"",
      userId: [],
      approvalType: "",
      minAmount: "",
      maxAmount: ""
    })
    
    useEffect(()=>{
      setAmountEdit({
        module: "refilling",
        status: editDataStatus,
        users: "",
        approvalType: editApprovalType || "",
        minAmount: amount.minAmount || "",
        maxAmount: amount.maxAmount || "",
        id:amount.id
      })
    },[amount,editApprovalType,editDataStatus])


    const formikAmountEdit = useFormik({
      enableReinitialize: true,
      initialValues: amountEdit,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema: yup.object({
        // email: yup.string().required('Email is required!'),
      }),
      onSubmit: async (value, { resetForm }) => {
        const valueData = {
          ...value,
          module: "refilling",
          status: editDataStatus,
          userId: userId
        }
        axiosInstance.put(`/status-permission/edit-permission/${value.id}`, valueData).then((res) => {
          if (res.data?.status === true) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Created Successfully.",
            });
            resetForm();
            getData();
            closeShowAmount();
          } else if (res.data?.status === false && res.data?.error) {
            toast.open({
              type: "error",
              message: "Error",
              description: res.data.error || "Network error.",
            });
          } else {
            toast.open({
              type: "warning",
              message: "Warning",
              description: res.data?.msg || "Warning.",
            });
          }
        });
      },
    });
  
    const getInitials = (name) => {
      const names = name.split(" ");
      if (names.length > 1) {
        return names[0][0] + names[1][0];
      }
      return names[0][0];
    };
    const closeFilterDialog = () => {
      setShowFilterDialog(false);
    };
    const closeShowAmount = () => {
      setShowAmount(false);
    };

    function handleDelete(e){
      axiosInstance.delete(`/status-permission/multi-delete/refilling/${e}`,).then(res=>{
  
        if(res?.data?.status == true){
          getData();
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Created Successfully.",
          });
        }else{
          toast.open({
            type: "error",
            message: "Error",
            description: res.data.error || "Network error.",
          });
        }
        
      }).catch(err=>{
        toast.open({
          type: "error",
          message: "Error",
          description: err.response.data.error || "Delete failed.",
        });
      })
    }

    return (
      <>
        <style jsx>{`
          .circle-container .circle {
            position: relative;
            display: inline-block;
          }
  
          .circle-container .circle .circle-tooltip {
            visibility: hidden;
            width: auto;
            background-color: #fff;
            color: #555;
            text-align: center;
            border-radius: 5px;
            padding: 5px;
            position: absolute;
            z-index: 20;
            bottom: 100%; /* Position the tooltip above the circle */
            left: 50%;
            transform: translateX(-50%);
            opacity: 0;
            transition: opacity 0.3s;
            border: 1px solid #048178;
          }
  
          .circle-container .circle:hover .circle-tooltip {
            visibility: visible;
            opacity: 1;
          }
        `}</style>
        <div className="ml-5">
         <p className="text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
    Refilling :
  </p>      </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="sm:flex justify-start">
            <MultiSelect
              label="User Name"
              placeholder="Choose"
              Options={user}
              formik={formik}
              name="users"
              isRequired={true}

              width="w-full md:w-1/2 lg:w-1/5"
            />
            <FormikSelectTwo
              label="Status"
              placeholder="Choose"
              Options={[
                {value: "Reviewed", label:"Reviewed"},
                {value: "Verified", label:"Verified"},
                {value: "Approved", label:"Approved"}
              ]}
              formik={formik}
              name="status"
              isRequired={true}

              width="w-full md:w-1/2 lg:w-1/5"
              zindex={50}
            />
            <FormikSelectTwo
            label="Type"
            placeholder="Choose"
            Options={[
              { value: "seal", label: "Seal" },
              { value: "signature", label: "Signature" },
            ]}
            formik={formik}
            name="approvalType"
            isRequired={true}

            width="w-full md:w-1/2 lg:w-1/5"
            zindex={50}
          />
          {/* <NuInput
           label="Maximum Amount"
           type="number"
           placeholder="Maximum Amount"
           formik={formik}
           name="maxAmount"
           isRequired={true}

           width="w-full md:w-1/2 lg:w-1/6"
           />
          <NuInput
           label="Minimum Amount"
           type="number"
           placeholder="Minimum Amount"
           formik={formik}
           name="minAmount"
           isRequired={true}

           width="w-full md:w-1/2 lg:w-1/6"
           /> */}
                                            {GetAccess('approvalpermission_create')&&
           
            <div className="w-10 h-12 mt-10 ml-5 sm:ml-0">
              <SubmitButton name="Add" />
            </div>}
          </div>
        </form>
        <table className=" w-[75%] h-64 ml-5 overflow-y-auto mt-2 ">
          <thead className="bg-[#F3F4F6]">
            <tr className="">
              <th className=" w-[30%] text-left text-sm font-medium py-2 px-4">
                Status
              </th>
              <th className=" w-[30%] text-left text-sm font-medium py-2 px-4">
                Users
              </th>
              <th className=" w-[30%] text-left text-sm font-medium py-2 px-4">
                Type
              </th>
              {/* <th className=" w-[15%] text-left text-sm font-medium py-2 px-4">
                Maximum Amount
              </th>
              <th className=" w-[15%] text-left text-sm font-medium py-2 px-4">
                Minimum Amount
              </th> */}
              <th className=" w-[10%] text-left text-sm font-medium py-2 px-4">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {data &&
              Object.keys(data).map((value, index) => {
                console.log("ddddddddd", data[value]);
                return (
                  <tr   className="odd:bg-white even:bg-slate-50 border-b border-gray-200"
 key={index}>
                    <td className="w-[20%] text-xs px-4">{value || "-"}</td>
                                     <td className="w-[20%]">
  <div className="w-1/2 py-3 pl-2 text-sm text-[#606279]">
    <div className="circle-container" style={{ display: "flex", alignItems: "center" }}>
      {Array.isArray(data[value]) && data[value].length > 0 ? (
        data[value].map((name, index) => (
          <div
            key={index}
            className="relative group" 
            onClick={() => {
              setShowAmount(true);
              setAmount({
                id: data[value][0].id,
                minAmount: data[value][0].minAmount,
                maxAmount: data[value][0].maxAmount
              });
              setEditDataStatus(value);
              setUserId(data[value][0].userId);
              setEditApprovalType(data[value][0].approvalType);
            }}
          >
            <div
              className="circle"
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                backgroundColor: "#048178",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "normal",
                marginLeft: index !== 0 ? "-10px" : "0",
                position: "relative",
                zIndex: 10 - index,
                transition: "all 0.3s ease",
                cursor: "pointer",
                border: "1px solid #fff"
              }}
            >
              {getInitials(name?.userName)}
            </div>
            {/* Tooltip */}
            <div
              className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-2 py-1 bg-white text-baseColor-primary border border-baseColor-primary text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity z-50 whitespace-nowrap"
            >
              {name?.userName}
            </div>
          </div>
        ))
      ) : (
        <p>-</p>
      )}
    </div>
  </div>
</td>
                    <td className="w-[20%] text-xs px-4 pt-5">
                    {data[value][0].approvalType || "-"}
                    </td>
                    {/* <td className="w-[15%] text-xs px-4 pt-5">
                      <NuAmount value={data[value][0].maxAmount} />
                    </td>
                    <td className="w-[15%] text-xs px-4 pt-5">
                     <NuAmount value={data[value][0].minAmount} />
                    </td> */}
                    <td className="w-[10%]">
                    <div className=" w-full flex gap-1 justify-center items-center">
                    {GetAccess('approvalpermission_edit')&&

                      <div
                        className="flex justify-center cursor-pointer"
                        onClick={() => {setShowFilterDialog(true); setEditDataStatus(value); setEditApprovalType(data[value][0].approvalType);}}
                      >
                        <EditIcon color="green" />
                      </div>}
                      {GetAccess('approvalpermission_delete')&&

                      <div
                      className="flex justify-center cursor-pointer"
                      onClick={() => {handleDelete(value)}}
                    >
                      <DeleteIcon/>
                    </div>}
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {showFilterDialog && (
          <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
            <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
              <h2 className="text-xl mb-4">Edit Permission</h2>
              <form onSubmit={formikEdit.handleSubmit}>
                <div className="flex flex-col mb-4">
                  <MultiSelect
                    label="User Name"
                    placeholder="Choose"
                    Options={user}
                    formik={formikEdit}
                    name="users"
                    width="w-full"
                  />
                  <FormikSelectTwo
            label="Type"
            placeholder="Choose"
            Options={[
              { value: "seal", label: "Seal" },
              { value: "signature", label: "Signature" },
            ]}
            formik={formikEdit}
            name="approvalType"
            width="w-full"
          />
                </div>
                <div className="flex justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialog} />
                  <SubmitButton name="Submit" />
                </div>
              </form>
            </div>
          </div>
        )}
        {showAmount && (
          <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
            <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
              <div className="w-full flex justify-between">
                <h2 className="text-xl mb-4">Edit Amount</h2>
                <div className="mt-0.5 cursor-pointer" onClick={()=>{setEditAmount(prev => !prev)}}>
                   <EditIcon color="yellow"/>
                </div>
              </div>
              <form onSubmit={formikAmountEdit.handleSubmit}>
                <div className="flex flex-col mb-4">
                <NuInput
           label="Maximum Amount"
           type="number"
           placeholder="Maximum Amount"
           formik={formikAmountEdit}
           name="maxAmount"
           width="w-full"
           disabled={editAmount === true ? false : true}
           />
          <NuInput
           label="Minimum Amount"
           type="number"
           placeholder="Minimum Amount"
           formik={formikAmountEdit}
           name="minAmount"
           width="w-full"
           disabled={editAmount === true ? false : true}
           />
                </div>
                <div className="flex justify-end gap-2">
                  <div onClick={()=>{setEditAmount(false)}}>
                  <CancelButton handleClick={closeShowAmount}/>
                  </div>
                  <div onClick={()=>{setEditAmount(false)}}>
                  <SubmitButton name="Submit"/>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </>
    );
}

export default RefillingPremission